import React, { PureComponent, Fragment } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';

const MediaLink = DisplayComponent(
  class MediaLink extends PureComponent {
    render() {
      const {
        linkDisplay,
        linkText,
        buttonColor,
        mediaFile,
        arrow
      } = this.props;
      return (
        <Fragment>
          {linkDisplay === 'text' && (
            <Link to={mediaFile} onClick={this.handleLinkClick}>
              {linkText}
            </Link>
          )}
          {linkDisplay === 'button' && (
            <Button
              to={mediaFile}
              color={buttonColor}
              onClick={this.handleLinkClick}
              arrow={arrow}
            >
              {linkText}
            </Button>
          )}
        </Fragment>
      );
    }
  }
);

export default MediaLink;
